import React, { useEffect, useState } from 'react';
import firebase from "../../firebaseConfig";
import "../../styles/generalTabs.css"
import {TiDelete, TiPlus} from "react-icons/ti";

const CausesSymptoms = ({ user }) => {
    const [data, setData] = useState([
        {
            context: "",
            pattern: "",
            riskDriverPhysical: "",
            riskDriverCognitive: "",
            riskDriverEmotional: "",
            redFlagsPhysical: "",
            redFlagsCognitive: "",
            redFlagsEmotional: "",
            preventionCost: "",
            preventionLevers: "",
            returnToBaseline: "",
            weeklyReview: ""
        }
    ]);

    useEffect(() => {
        const fetchInputValue = async () => {
            try {
                if (user) {
                    const userId = user.uid;
                    const docRef = firebase.firestore().collection('users').doc(userId);
                    const docSnapshot = await docRef.get();
                    if (docSnapshot.exists) {
                        const fetchedData = docSnapshot.data().OverloadBurnoutPrevention_10 || [
                            {
                                context: "",
                                pattern: "",
                                riskDriverPhysical: "",
                                riskDriverCognitive: "",
                                riskDriverEmotional: "",
                                redFlagsPhysical: "",
                                redFlagsCognitive: "",
                                redFlagsEmotional: "",
                                preventionCost: "",
                                preventionLevers: "",
                                returnToBaseline: "",
                                weeklyReview: ""
                            }
                        ];
                        setData(fetchedData);
                    }
                }
            } catch (error) {
                console.error("Error fetching data:", error);
            }
        };
        fetchInputValue();
    }, [user]);

    const updateField = async (index, field, value) => {
        const newData = [...data];
        newData[index][field] = value;
        setData(newData);

        try {
            if (user) {
                const userId = user.uid;
                const docRef = firebase.firestore().collection('users').doc(userId);
                await docRef.update({
                    OverloadBurnoutPrevention_10: newData
                });
            }
        } catch (error) {
            console.error("Error updating data:", error);
        }
    };

    const addRow = async () => {
        const newRow = {
            context: "",
            pattern: "",
            riskDriverPhysical: "",
            riskDriverCognitive: "",
            riskDriverEmotional: "",
            redFlagsPhysical: "",
            redFlagsCognitive: "",
            redFlagsEmotional: "",
            preventionCost: "",
            preventionLevers: "",
            returnToBaseline: "",
            weeklyReview: ""
        };
        const newData = [...data, newRow];
        setData(newData);

        try {
            if (user) {
                const userId = user.uid;
                const docRef = firebase.firestore().collection('users').doc(userId);
                await docRef.update({
                    OverloadBurnoutPrevention_10: newData
                });
            }
        } catch (error) {
            console.error("Error adding row:", error);
        }
    };

    const deleteRow = async (index) => {
        const newData = data.filter((_, i) => i !== index);
        setData(newData);

        try {
            if (user) {
                const userId = user.uid;
                const docRef = firebase.firestore().collection('users').doc(userId);
                await docRef.update({
                    OverloadBurnoutPrevention_10: newData
                });
            }
        } catch (error) {
            console.error("Error deleting row:", error);
        }
    };

    const EditableCell = ({ value, onChange }) => {
        const [isEditing, setIsEditing] = useState(false);
        const [tempValue, setTempValue] = useState(value);

        useEffect(() => {
            setTempValue(value);
        }, [value]);

        const handleBlur = () => {
            setIsEditing(false);
            onChange(tempValue);
        };

        const handleKeyDown = (e) => {
            if (e.key === 'Enter') {
                handleBlur();
            } else if (e.key === 'Escape') {
                setIsEditing(false);
                setTempValue(value);
            }
        };

        if (isEditing) {
            return (
                <textarea
                    value={tempValue}
                    onChange={(e) => setTempValue(e.target.value)}
                    onBlur={handleBlur}
                    onKeyDown={handleKeyDown}
                    autoFocus
                    className="form-control"
                    style={{ minHeight: '60px' }}
                />
            );
        }

        return (
            <div
                onClick={() => setIsEditing(true)}
                className="contentText"
                style={{ 
                    cursor: 'pointer', 
                    minHeight: '60px',
                    padding: '8px',
                    border: '1px dashed transparent',
                    borderRadius: '4px'
                }}
                onMouseEnter={(e) => e.target.style.border = '1px dashed #ccc'}
                onMouseLeave={(e) => e.target.style.border = '1px dashed transparent'}
            >
                {value || <span style={{ color: '#ccc' }}>Click to edit...</span>}
            </div>
        );
    };

    return (
        <div className="tab-pane containerDashboardContent container-fluid" role="tabpanel" id="tab-10">
            <h5 className={"mt-3"}>
                <span className="introText">
                     "If your working circumstances are costing you your physical, mental, and emotional health, it's too expensive." - Robin Kirby
                </span>
            </h5>
            <div>
                <div className="table-responsive d-flex flex-column align-items-center">
                    <table className="table w-100">
                        <thead>
                            <tr>
                                <th style={{ backgroundColor: '#f0f0f0', border: '1px solid #ddd', width: '25%' }}>
                                    <span style={{ textDecoration: "underline", fontSize: "1.2em", fontWeight: 'bold' }}>CONTEXT + PATTERNS</span>
                                </th>
                                <th style={{ backgroundColor: '#f0f0f0', border: '1px solid #ddd', width: '25%' }}>
                                    <span style={{ textDecoration: "underline", fontSize: "1.2em", fontWeight: 'bold' }}>RISK DRIVERS</span>
                                </th>
                                <th style={{ backgroundColor: '#f0f0f0', border: '1px solid #ddd', width: '25%' }}>
                                    <span style={{ textDecoration: "underline", fontSize: "1.2em", fontWeight: 'bold' }}>RED FLAGS</span>
                                </th>
                                <th style={{ backgroundColor: '#f0f0f0', border: '1px solid #ddd', width: '25%' }}>
                                    <span style={{ textDecoration: "underline", fontSize: "1.2em", fontWeight: 'bold' }}>PREVENTION LEVERS + RETURN-TO-BASELINE</span>
                                </th>
                                <th style={{ backgroundColor: '#f0f0f0', border: '1px solid #ddd', width: '50px' }}></th>
                            </tr>
                        </thead>
                        <tbody>
                            {data.map((item, index) => (
                                <tr key={index}>
                                    <td style={{ border: '1px solid #ddd', verticalAlign: 'top', height: '400px' }}>
                                        <div style={{ height: '50%', display: 'flex', flexDirection: 'column' }}>
                                            <strong>Context:</strong>
                                            <EditableCell 
                                                value={item.context} 
                                                onChange={(value) => updateField(index, 'context', value)} 
                                            />
                                        </div>
                                        <div style={{ height: '50%', display: 'flex', flexDirection: 'column' }}>
                                            <strong>Pattern:</strong>
                                            <EditableCell 
                                                value={item.pattern} 
                                                onChange={(value) => updateField(index, 'pattern', value)} 
                                            />
                                        </div>
                                    </td>
                                    <td style={{ border: '1px solid #ddd', verticalAlign: 'top', height: '400px' }}>
                                        <div style={{ height: '33.33%', display: 'flex', flexDirection: 'column' }}>
                                            <strong>Physical:</strong>
                                            <EditableCell 
                                                value={item.riskDriverPhysical} 
                                                onChange={(value) => updateField(index, 'riskDriverPhysical', value)} 
                                            />
                                        </div>
                                        <div style={{ height: '33.33%', display: 'flex', flexDirection: 'column' }}>
                                            <strong>Cognitive:</strong>
                                            <EditableCell 
                                                value={item.riskDriverCognitive} 
                                                onChange={(value) => updateField(index, 'riskDriverCognitive', value)} 
                                            />
                                        </div>
                                        <div style={{ height: '33.33%', display: 'flex', flexDirection: 'column' }}>
                                            <strong>Emotional:</strong>
                                            <EditableCell 
                                                value={item.riskDriverEmotional} 
                                                onChange={(value) => updateField(index, 'riskDriverEmotional', value)} 
                                            />
                                        </div>
                                    </td>
                                    <td style={{ border: '1px solid #ddd', verticalAlign: 'top', height: '400px' }}>
                                        <div style={{ height: '33.33%', display: 'flex', flexDirection: 'column' }}>
                                            <strong>Physical:</strong>
                                            <EditableCell 
                                                value={item.redFlagsPhysical} 
                                                onChange={(value) => updateField(index, 'redFlagsPhysical', value)} 
                                            />
                                        </div>
                                        <div style={{ height: '33.33%', display: 'flex', flexDirection: 'column' }}>
                                            <strong>Cognitive:</strong>
                                            <EditableCell 
                                                value={item.redFlagsCognitive} 
                                                onChange={(value) => updateField(index, 'redFlagsCognitive', value)} 
                                            />
                                        </div>
                                        <div style={{ height: '33.33%', display: 'flex', flexDirection: 'column' }}>
                                            <strong>Emotional:</strong>
                                            <EditableCell 
                                                value={item.redFlagsEmotional} 
                                                onChange={(value) => updateField(index, 'redFlagsEmotional', value)} 
                                            />
                                        </div>
                                    </td>
                                    <td style={{ border: '1px solid #ddd', verticalAlign: 'top', height: '400px' }}>
                                        <div style={{ height: '25%', display: 'flex', flexDirection: 'column' }}>
                                            <strong>Cost:</strong>
                                            <EditableCell 
                                                value={item.preventionCost} 
                                                onChange={(value) => updateField(index, 'preventionCost', value)} 
                                            />
                                        </div>
                                        <div style={{ height: '25%', display: 'flex', flexDirection: 'column' }}>
                                            <strong>Prevention Levers:</strong>
                                            <EditableCell 
                                                value={item.preventionLevers} 
                                                onChange={(value) => updateField(index, 'preventionLevers', value)} 
                                            />
                                        </div>
                                        <div style={{ height: '25%', display: 'flex', flexDirection: 'column' }}>
                                            <strong>Return-to-Baseline:</strong>
                                            <EditableCell 
                                                value={item.returnToBaseline} 
                                                onChange={(value) => updateField(index, 'returnToBaseline', value)} 
                                            />
                                        </div>
                                        <div style={{ height: '25%', display: 'flex', flexDirection: 'column' }}>
                                            <strong>Weekly Review:</strong>
                                            <EditableCell 
                                                value={item.weeklyReview} 
                                                onChange={(value) => updateField(index, 'weeklyReview', value)} 
                                            />
                                        </div>
                                    </td>
                                    <td style={{ border: '1px solid #ddd', verticalAlign: 'top', textAlign: 'center' }}>
                                        <TiDelete 
                                            style={{ fontSize: "1.5em", cursor: "pointer" }} 
                                            className={"text-danger mt-2"} 
                                            onClick={() => deleteRow(index)}
                                        />
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                    <div className="w-100 d-flex justify-content-center mt-3">
                        <TiPlus 
                            style={{ fontSize: "1.8em", cursor: "pointer" }} 
                            className={"text-primary"} 
                            onClick={addRow}
                        />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default CausesSymptoms;
